var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.517 15.8874H3.375C3.22582 15.8874 3.08274 15.8281 2.97725 15.7226C2.87176 15.6171 2.8125 15.4741 2.8125 15.3249V12.1829C2.8125 12.109 2.82705 12.0358 2.85532 11.9676C2.88359 11.8994 2.92502 11.8373 2.97725 11.7851L11.4148 3.34761C11.5202 3.24212 11.6633 3.18286 11.8125 3.18286C11.9617 3.18286 12.1048 3.24212 12.2102 3.34761L15.3523 6.48962C15.4577 6.59511 15.517 6.73818 15.517 6.88737C15.517 7.03655 15.4577 7.17962 15.3523 7.28511L6.91475 15.7226C6.86252 15.7748 6.80051 15.8163 6.73226 15.8445C6.66402 15.8728 6.59087 15.8874 6.517 15.8874Z",
    stroke: "#0044BB",
    strokeWidth: 1.07904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 5.19983L13.5 9.13733",
    stroke: "#0044BB",
    strokeWidth: 1.07904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71442 15.8514L2.84863 11.9856",
    stroke: "#0044BB",
    strokeWidth: 1.07904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.7c039bcca388e3cbe2d350b673d67492.svg";
export { ForwardRef as ReactComponent };